import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Box, Grid, IconButton, Tooltip } from '@material-ui/core';
import Card from '../../Card/Card.js';
import CardBody from '../../Card/CardBody.js';
import HousingTradelifeIcon from '../../../assets/img/planner-housing-tradelife-icon.svg';
import HomeIcon from '@material-ui/icons/Home';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/Check';
import HelpOutlineIcon from '@material-ui/icons/Timer';
import { dateToS } from '../../../util/dateUtil';
import { isStudent, isAlumni, isAdminOrFHT, isFHT } from '../../../util/miscUtil';

const AftercareApps = ({
  senior,
  alumni,
  roles,
  aftercareSpecialist,
  aftercareList,
  countOpenApplications,
  setPage,
  handleReturnToSeniorList,
  showReturnedAftercareApp,
  displayStatus,
  formatPhoneNumber,
  handleCreateAftercareApp,
  openAftercareApp,
  classes,
  handleGotoAdminHomepage,
}) => {
  window.scrollTo({ top: 0 });

  return (
    <summary className={classes.subPageContainer}>
      <div style={{ width: '100%', margin: 0 }} className={classes.pageBanner}>
        <div className={classes.centerForm}>
          <Box
            sx={{
              width: '100%',
              maxWidth: {
                xs: '380px',
                sm: '540px',
                md: '868px',
                lg: '1320px',
                xl: '1320px',
              },
            }}
          >
            <Grid container spacing={0} direction="row">
              <Grid item xs={12} align="left">
                <summary className={classes.header} style={{ paddingTop: '30px' }}>
                  <Grid container direction="row" style={{ width: '100%' }}>
                    <Grid item xs={false} sm={1} md={1} lg={1} align="center" className={classes.logoContainer}>
                      <img src={HousingTradelifeIcon} alt="Housing and Community Supports Icon" className={classes.logo} />
                    </Grid>
                    <Grid item xs={12} sm={11} md={11} lg={11} align="left">
                      <Grid container spacing={0} direction="row" style={{ width: '100%' }}>
                        <Grid item xs={9} sm={9} md={9} lg={10} align="left" style={{ width: '100%' }}>
                          <div className={classes.headerContent}>
                            <div className={classes.headerText}>
                              <div className={classes.title}>
                                {isStudent(roles) || isAlumni(roles) ? (
                                  <main>Community Supports/Housing Applications</main>
                                ) : (
                                  <main style={{ fontSize: '1.25rem' }}>
                                    Community Supports/Housing Applications for{' '}
                                    {senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                                    {senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                                  </main>
                                )}
                              </div>
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} lg={2} align="center" style={{ width: '100%' }}>
                          <IconButton color="inherit" aria-label="return home" onClick={(e) => setPage('home')}>
                            <HomeIcon className={classes.homeIcon} style={{ color: '#fff' }} />
                          </IconButton>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} style={{ marginTop: '15px' }}>
                          <aside style={{ textAlign: 'left' }}>
                            <label className={classes.subPageContactInfoLabel}>Successful Futures Specialist:</label>{' '}
                            <span className={classes.subPageContactInfo}>
                              {aftercareSpecialist && aftercareSpecialist.user && aftercareSpecialist.user.id > 0
                                ? aftercareSpecialist.user.first_name + ' ' + aftercareSpecialist.user.last_name
                                : 'N/A'}
                            </span>
                          </aside>
                          <aside style={{ textAlign: 'left' }}>
                            <label className={classes.subPageContactInfoLabel}>Office Phone</label>{' '}
                            <span className={classes.subPageContactInfo}>
                              {(aftercareSpecialist &&
                                aftercareSpecialist.user &&
                                aftercareSpecialist.user.id > 0 &&
                                formatPhoneNumber(aftercareSpecialist.office_phone)) ||
                                'N/A'}
                            </span>
                          </aside>
                          <aside style={{ textAlign: 'left' }}>
                            <label className={classes.subPageContactInfoLabel}>Cell Phone</label>{' '}
                            <span className={classes.subPageContactInfo}>
                              {(aftercareSpecialist &&
                                aftercareSpecialist.user &&
                                aftercareSpecialist.user.id > 0 &&
                                formatPhoneNumber(aftercareSpecialist.cell_phone)) ||
                                'N/A'}
                            </span>
                          </aside>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </summary>
              </Grid>
            </Grid>
          </Box>
        </div>

        {isAdminOrFHT(roles) && (
          <div className={classes.centerForm}>
            <Box
              sx={{
                width: '100%',
                maxWidth: {
                  xs: '380px',
                  sm: '540px',
                  md: '868px',
                  lg: '1280px',
                  xl: '1280px',
                },
              }}
            >
              <div className={classes.breadcrumbs}>
                <Breadcrumbs separator="›" aria-label="breadcrumbs" className={classes.alignCrumb}>
                  <span className={classes.breadCrumbLink} onClick={(e) => handleGotoAdminHomepage()}>
                    <HomeIcon style={{ fontSize: '1.30rem' }} />
                    <span style={{ margin: '1px 0 0 1px' }}>Home</span>
                  </span>
                  <span className={classes.breadCrumbLink} onClick={(event) => handleReturnToSeniorList()}>
                    {alumni ? 'Alumni' : 'High School Seniors'}
                  </span>
                  <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(e) => setPage('home')}>
                    {senior && senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                    {senior && senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                  </span>
                  <span className={classes.breadCrumbText} style={{ marginTop: '-1px' }}>
                    Community Supports/Housing Applications
                  </span>
                </Breadcrumbs>
              </div>
            </Box>
          </div>
        )}
      </div>

      <div className={classes.centerForm}>
        <Box
          sx={{
            width: '100%',
            maxWidth: {
              xs: '380px',
              sm: '540px',
              md: '868px',
              lg: '1280px',
              xl: '1280px',
            },
          }}
        >
          <Grid container spacing={3} direction="row" className={classes.menu}>
            <Grid item xs={12} align="center">
              {(isStudent(roles) || isAlumni(roles)) && showReturnedAftercareApp && (
                <aside className={classes.error}>NOTE: You have a returned Community Supports/Housing application. Please review immediately!</aside>
              )}
            </Grid>
          </Grid>
        </Box>
      </div>

      <div className={classes.centerForm}>
        <Box
          sx={{
            width: '100%',
            maxWidth: {
              xs: '380px',
              sm: '540px',
              md: '868px',
              lg: '1320px',
              xl: '1320px',
            },
          }}
        >
          <Grid container spacing={3} direction="row" className={classes.menu}>
            {isAdminOrFHT(roles) && aftercareList.length === 0 && (
              <Grid item xs={12} align="center">
                <summary className={classes.noApps}>
                  {senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name} has not created any Community
                  Supports/Housing applications.
                </summary>
              </Grid>
            )}

            <Grid item xs={12} align="left" className={classes.cardGrid} style={{ width: '100%', marginTop: '75px' }}>
              {countOpenApplications() === 0 && (isStudent(roles) || isAlumni(roles)) && (
                <nav onClick={(event) => handleCreateAftercareApp()} className={classes.nav} disabled={!isStudent(roles) && !isAlumni(roles)}>
                  <Card className={classes.card}>
                    <CardBody className={classes.cardBody}>
                      <div className={classes.cardContainer}>
                        <img src={HousingTradelifeIcon} alt="Housing and Community Supports Icon" className={classes.cardIcon} />

                        <Tooltip title="Click to create a new Community Supports/Housing application." placement="bottom">
                          <section className={classes.addSection}>
                            <AddIcon className={classes.addIcon} />
                          </section>
                        </Tooltip>
                      </div>
                    </CardBody>
                  </Card>
                </nav>
              )}

              {aftercareList.map((app, idx) => {
                return (
                  <nav onClick={(event) => !isFHT(roles) && openAftercareApp(app.id)} className={classes.nav}>
                    <Card className={classes.card}>
                      <CardBody className={classes.cardBody}>
                        <div className={classes.cardContainer}>
                          <img src={HousingTradelifeIcon} alt="Housing and Community Supports Icon" className={classes.cardIcon} />
                          <section className={classes.submittedDateLabel}>
                            {app.submitted_date ? (
                              <>
                                Submitted Date: <span className={classes.cardHeader}>{app.submitted_date && dateToS(app.submitted_date)}</span>
                              </>
                            ) : (
                              <span style={{ fontSize: '1.05rem', fontWeight: 'bold', opacity: '.9' }}>Unsubmitted</span>
                            )}
                          </section>
                          <summary className={classes.cardAlignBottom} style={{ width: '100%', textAlign: 'center' }}>
                            <div style={{ textAlign: 'center' }}>
                              <div className={classes.appStatus} style={{ width: '100%' }}>
                                {app.status === 'awarded' ? (
                                  <CheckIcon className={classes.statusIcon} style={{ color: app.status === 'returned' ? 'red' : '#000' }} />
                                ) : app.status === 'approved' || app.status === 'denied' || app.status.toLowerCase() === 'approvedalternate' ? (
                                  <CheckIcon className={classes.statusIcon} style={{ color: app.status === 'returned' ? 'red' : '#000' }} />
                                ) : app.status === 'qualified' || app.status === 'qualifiedinitial' || app.status === 'qualifiedprogram' ? (
                                  <HelpOutlineIcon className={classes.statusIcon} style={{ color: app.status === 'returned' ? 'red' : '#000' }} />
                                ) : (
                                  <HelpOutlineIcon className={classes.statusIcon} style={{ color: app.status === 'returned' ? 'red' : '#000' }} />
                                )}{' '}
                                <span
                                  className={classes.iconText}
                                  style={{
                                    fontWeight: 600,
                                    color: app.status === 'returned' ? 'red' : '#000',
                                  }}
                                >
                                  {displayStatus(app.status)}
                                </span>
                              </div>
                            </div>
                            <div style={{ textAlign: 'center' }}>
                              <span className={classes.iconText}>{dateToS(app.status_date)}</span>
                            </div>
                          </summary>
                        </div>
                      </CardBody>
                    </Card>
                  </nav>
                );
              })}
            </Grid>
          </Grid>
        </Box>
      </div>
    </summary>
  );
};

AftercareApps.propTypes = {
  senior: PropTypes.object,
  alumni: PropTypes.bool,
  roles: PropTypes.array,
  aftercareSpecialist: PropTypes.object,
  aftercareList: PropTypes.array,
  setPage: PropTypes.func,
  handleReturnToSeniorList: PropTypes.func,
  showReturnedAftercareApp: PropTypes.func,
  displayStatus: PropTypes.func,
  formatPhoneNumber: PropTypes.func,
  countOpenApplications: PropTypes.func,
  handleCreateAftercareApp: PropTypes.func,
  openAftercareApp: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleGotoAdminHomepage: PropTypes.func.isRequired,
};

export default AftercareApps;
